import React, {useEffect, useState} from 'react'
import styles from './Viewer.toolbar.module.sass'
import ToolbarToolRange from './Tool/Toolbar.toolRange'
import ToolbarToolClicker from './Tool/Toolbar.toolClicker'
import {iconsGallery} from '../../../assets/icons'
import {observer} from 'mobx-react'
import styled from 'styled-components'
import GlobalStore from '../../../stores/global.store'
import moment from "moment";
import {getTimer, timerHandler} from "./Tool/TimerTools";
// export type ToolbarTool = {
//   icon: () => ReactElement
//   name: string
//   onChange: Function | null
//   type: 'range' | 'clicker'
// }


const ViewMode = styled.div`
  display: flex;
  height: 100px;
  align-items: center;
  margin-left: 40px;

  div {
    margin-left: 10px;
  }
`

const ViewerToolbar = observer((props) => {

    const [timer, setTimer] = useState()
    const [isTimer, setIsTimer] = useState(false)

    useEffect(() => {
        let interval
        if (timer && !isTimer) {
            interval = setInterval(() => {
                setTimer(value => value - 1)
            }, 1000)
            setIsTimer(true)
        }
        if (!getTimer(timer)) {
            clearInterval(interval)
        }

    }, [timer])

    useEffect(() => {
        if (!timer && props?.store?.timer) {
            setTimer(timerHandler(props?.store?.timer))
        }
    }, [props?.store?.timer])


    const {fullScreenMode, toggleFullScreen} = GlobalStore
	
    const toolbar = [
        {
            icon: iconsGallery.brightnessSVG,
            type: 'range',
            name: 'brightness',
            onChange: (e) => {
                props.store.brightness(e[0] / 50)
            }
        },
        {
            icon: iconsGallery.contrastSVG,
            type: 'range',
            name: 'contrast',
            onChange: (e) => {
                props.store.contrast(e[0] / 50)
            }
        },
        {
            icon: iconsGallery.invertSVG,
            type: 'clicker',
            name: 'invert',
            onChange: () => {
                props.store.invert()
            }
        },
        {
            icon: iconsGallery.rotateLeft,
            type: 'clicker',
            name: 'rotate left',
            onChange: () => {
                props.store.rotate(-90)
            }
        },
        {
            icon: iconsGallery.rotateRight,
            type: 'clicker',
            name: 'rotate right',
            onChange: () => {
                props.store.rotate(90) 
            }
        },
        {
            icon: iconsGallery.mirrorH,
            type: 'clicker',
            name: 'mirror h',
            onChange: () => {
                props.store.mirrorH()
            }
        },
        {
            icon: iconsGallery.mirrorV,
            type: 'clicker',
            name: 'mirror v',
            onChange: () => {
                props.store.mirrorV()
            }
        },
        {
            icon: iconsGallery.minusSVG,
            type: 'clicker',
            name: 'minus',
            onChange: () => {
                props.store.zoom(1, -0.25)
            }
        },
        {
            icon: iconsGallery.plusSVG,
            type: 'clicker',
            name: 'plus',
            onChange: () => {
                props.store.zoom(1, 0.25)
            }
        },
        {
            icon: iconsGallery.loupeSVG,
            type: 'clicker',
            active: props.store.magnifier,
            name: 'loupe',
            onChange: () => {
                props.store.toggleMagnifier()
            }
        }
    ]

    return (
        <>
            <div className={styles.ViewerToolbar}>
                <div className={styles.ViewerToolbarWrapper}>
                    {toolbar.map((tool) => {
                        if (tool.type == 'range')
                            return (
                                <ToolbarToolRange
                                    key={tool.name}
                                    icon={tool.icon}
                                    onChange={tool.onChange}
                                />
                            )
                        if (tool.type == 'clicker')
                            return (
                                <ToolbarToolClicker
                                    key={tool.name}
                                    icon={tool.icon}
                                    active={tool.active}
                                    onChange={tool.onChange}
                                />
                            )
                    })}
                    <StyledExpand onClick={toggleFullScreen}>
                        <i className='fas fa-expand-arrows-alt'/>
                    </StyledExpand>
                </div>
                <ViewMode>
                    <ToolbarToolClicker
                        active={props.store.viewerMode === 4}
                        icon={iconsGallery.viewMode4}
                        onChange={(_) => props.store.changeViewerMode(4)}
                    />
                    <ToolbarToolClicker
                        active={props.store.viewerMode === 2}
                        icon={iconsGallery.viewMode2}
                        onChange={(_) => props.store.changeViewerMode(2)}
                    />
                    <ToolbarToolClicker
                        active={props.store.viewerMode === 1}
                        icon={iconsGallery.viewMode1}
                        onChange={(_) => props.store.changeViewerMode(1)}
                    />
                </ViewMode>
                <div className={styles.count}>{props.store.count}</div>
                <Timer>{timer ? getTimer(timer) : ""}</Timer>
            </div>
        </>
    )
})

const StyledExpand = styled.div`
  font-size: 25px;
  cursor: pointer;
  margin-left: -5px;
`

const Timer = styled.div`
  position: absolute;
  right: 20px;
  font-weight: bold;

  .red {
    color: red;
  }
`

export default ViewerToolbar
